module.exports = __webpack_public_path__ + "static/media/celo.7cfc3433.png";